const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20romantic%20scene%20collage%20of%20love%20stories%20through%20different%20decades%2C%20vintage%20film%20strips%2C%20warm%20nostalgic%20color%20grading%2C%20classic%20movie%20poster%20composition%2C%20elegant%20typography%20space%2C%20golden%20and%20sepia%20tones&width=1000&height=560&seq=carousel-topic-01&orientation=landscape',
    tag: '专题',
    title: '跨越时代的爱情经典',
    desc: '从黑白胶片到数字时代，精选50部横跨世纪的浪漫电影经典之作',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20intimate%20dinner%20scene%20with%20a%20couple%20toasting%20wine%20glasses%20at%20a%20candlelit%20table%2C%20elegant%20home%20dining%20setup%2C%20soft%20romantic%20lighting%2C%20cozy%20luxury%20atmosphere%2C%20cinematic%20depth%20of%20field&width=1000&height=560&seq=carousel-topic-02&orientation=landscape',
    tag: '策划',
    title: '七夕浪漫观影计划',
    desc: '为七夕精心设计的二人世界电影之夜，从片单到氛围全攻略',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20film%20reels%20and%20movie%20tickets%20scattered%20among%20dried%20roses%20and%20old%20love%20letters%2C%20warm%20amber%20lighting%2C%20vintage%20aesthetic%2C%20nostalgic%20film%20photography%20style&width=1000&height=560&seq=carousel-topic-03&orientation=landscape',
    tag: '盘点',
    title: '2026上半年最佳夫妻电影',
    desc: '综合热度、口碑与观众反馈，盘点今年最值得夫妻共赏的佳作',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cozy%20outdoor%20movie%20night%20setup%20in%20a%20beautiful%20backyard%20with%20string%20lights%2C%20projector%20screen%2C%20comfortable%20seating%20with%20pillows%20and%20blankets%2C%20starry%20night%20sky%2C%20warm%20atmospheric%20lighting&width=1000&height=560&seq=carousel-topic-04&orientation=landscape',
    tag: '指南',
    title: '打造家庭影院完全攻略',
    desc: '从设备到片单，一步步教你打造专属的夫妻影院观影空间',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
        <div className="text-center mb-12">
          <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            深度内容
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            围绕夫妻电影与二人世界电影主题的深度策划内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer bg-background-50"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`夫妻影院焦点专题 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="inline-block bg-accent-500 text-white text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}